import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { Group, MeshBasicMaterial } from 'three';

import { CLOUDS_TRANSITION_STAGE, useThreeStore } from 'state/threeStore';

import { Cloud, Clouds } from './Cloud/Cloud';
import TRANSITIONS from './CloudTransition.animations';
import * as U from './CloudTransition.utils';

import useMatrixUpdateHandler from 'hooks/useMatrixUpdateHandler';

const CloudTransition = () => {
  const cloudsRef = useRef<Group>(null!);
  const savedStageRef = useRef<CLOUDS_TRANSITION_STAGE>(null!);

  useFrame(() => {
    const {
      cloudsTransition: { stage },
    } = useThreeStore.getState();

    if (stage === savedStageRef.current) return;
    runTransition(stage!);
    savedStageRef.current = stage!;
  });

  const runTransition = (stage: CLOUDS_TRANSITION_STAGE) => {
    if (!cloudsRef.current) return;

    if (stage === 'HIDDEN') {
      // initialization
      U.findTransparentMaterials(cloudsRef.current).forEach(
        material => (material.opacity = 0)
      );

      return;
    }

    TRANSITIONS[stage]?.(cloudsRef.current);
  };

  useMatrixUpdateHandler(() => cloudsRef.current.visible, cloudsRef.current);

  return (
    <Clouds
      material={MeshBasicMaterial}
      frustumCulled={false}
      renderOrder={10}
      ref={cloudsRef}
      scale={[5, 5, 5]}
      visible={false}
    >
      <Cloud
        position={[0, 0, 100]}
        segments={50}
        bounds={[30, 20, 50]}
        concentrate="random"
        volume={15}
      />
      <Cloud
        position={[0, 0, 50]}
        segments={100}
        bounds={[40, 40, 40]}
        concentrate="random"
        volume={90}
      />
      <Cloud
        position={[0, 0, 20]}
        segments={50}
        bounds={[20, 20, 20]}
        concentrate="random"
        volume={15}
      />
    </Clouds>
  );
};

export default CloudTransition;
